module.exports = __webpack_public_path__ + "img/Main1.ad7bbb50.jpg";